import React from 'react';

// Fire emoji image URL
const FIRE_EMOJI_URL = 'https://customer-assets.emergentagent.com/job_9807a88a-e821-4e91-9d32-0ee714ec2eff/artifacts/3p8zzbnt_image.png';

/**
 * FireEmoji Component - Custom Fire Image
 * Used across the platform for fire reactions
 * 
 * Props:
 * - size: 'sm' | 'md' | 'lg' (default: 'md')
 * - count: number (fire count to display)
 * - isActive: boolean (has user fired - shows glow effect)
 * - onClick: function
 * - disabled: boolean
 * - showCount: boolean (default: true)
 * - isDarkMode: boolean
 */
const FireEmoji = ({ 
  size = 'md', 
  count = 0, 
  isActive = false, 
  onClick,
  disabled = false,
  showCount = true,
  isDarkMode = true,
  className = ''
}) => {
  // Size configurations
  const sizes = {
    sm: {
      icon: 'w-5 h-5',
      countText: 'text-[9px]',
      wrapper: 'gap-0.5'
    },
    md: {
      icon: 'w-6 h-6',
      countText: 'text-[10px]',
      wrapper: 'gap-0.5'
    },
    lg: {
      icon: 'w-8 h-8',
      countText: 'text-xs',
      wrapper: 'gap-1'
    }
  };

  const sizeConfig = sizes[size] || sizes.md;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      data-testid="fire-emoji-btn"
      className={`flex flex-col items-center ${sizeConfig.wrapper} transition-all ${
        disabled ? 'cursor-default' : 'cursor-pointer hover:scale-110 active:scale-125'
      } ${className}`}
    >
      {/* Count above the fire */}
      {showCount && (
        <span className={`${sizeConfig.countText} font-semibold tabular-nums ${
          isActive ? 'text-orange-500' : (isDarkMode ? 'text-gray-400' : 'text-gray-500')
        }`}>
          {count}
        </span>
      )}
      
      {/* Fire emoji image - glow effect when active, no gray out */}
      <img 
        src={FIRE_EMOJI_URL}
        alt="Fire"
        className={`${sizeConfig.icon} object-contain transition-all duration-200`}
        style={{
          filter: isActive 
            ? 'drop-shadow(0 0 10px rgba(249, 115, 22, 1)) drop-shadow(0 0 20px rgba(249, 115, 22, 0.7)) drop-shadow(0 0 30px rgba(249, 115, 22, 0.4))' 
            : undefined
        }}
      />
    </button>
  );
};

export default FireEmoji;
